<template>
  <div class="c-specialPeriods">
    <div
      class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border o-grid o-grid--gutter-tiny o-grid--align-items-center"
    >
      <div class="o-grid__group">
        <div class="o-grid__item">
          <h3 class="o-heading o-heading--bold o-heading--size-3">
            {{ translationsSpecialPeriods.sectionName || name }}
          </h3>
        </div>
      </div>
    </div>
    <div
      v-for="(period, periodIndex) in availabilityAll.special"
      :key="periodIndex"
      class="c-specialPeriods__period"
    >
      <div class="c-specialPeriods__period-head">
        <div
          class="o-grid o-grid--gutter-small o-grid--align-items-center o-field o-field--spacing-none o-field--border o-field--border-none"
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--3">
              <b>{{ translationsSpecialPeriods.sectionName }}</b>
            </div>
            <div class="o-grid__item o-grid__item--8">
              <div
                class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
              >
                <div class="o-grid__group">
                  <div class="o-grid__item o-grid__item--grow-0">
                    {{ translationsSpecialPeriods.from || "" }}
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <v-datepicker
                      :disabled="!isEditing"
                      input-class="c-aed-editableDate__input"
                      wrapper-class="c-aed-editableDate__wrap"
                      calendar-class="c-aed-editableDate__calendar"
                      :value="period.Monday.begin"
                      :use-utc="false"
                      format="dd-MM-yyyy"
                      :mondayFirst="true"
                      :language="datepickerLanguage"
                      :disabledDates="{
                        to: minimumSelectableDay
                      }"
                      :calendar-button="true"
                      calendar-button-icon="o-svg-icon o-svg-icon--calendar"
                      @input="updatePeriodDays(periodIndex, 'begin', $event)"
                    ></v-datepicker>
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0"></div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    {{ translationsSpecialPeriods.to || "" }}
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <v-datepicker
                      :disabled="!isEditing"
                      input-class="c-aed-editableDate__input"
                      wrapper-class="c-aed-editableDate__wrap"
                      calendar-class="c-aed-editableDate__calendar"
                      :value="period.Monday.end"
                      :use-utc="false"
                      format="dd-MM-yyyy"
                      :mondayFirst="true"
                      :language="datepickerLanguage"
                      :disabledDates="{
                        to: minimumSelectableDay
                      }"
                      :calendar-button="true"
                      calendar-button-icon="o-svg-icon o-svg-icon--calendar"
                      @input="updatePeriodDays(periodIndex, 'end', $event)"
                    ></v-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="o-grid__item o-grid__item--grow-0 o-grid__item--align-right"
            >
              <button
                v-if="isEditing"
                class="o-button o-button--action o-button--round o-button--light"
                @click="deleteSpecialPeriod(periodIndex)"
              >
                <svg
                  class="o-svg-icon o-button__icon"
                  viewBox="0 0 64 64"
                  type="image/svg+xml"
                >
                  <use
                    xlink:href="spritemap.svg#sprite-delete"
                    x="0"
                    y="0"
                  ></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="c-specialPeriods__period-body">
        <div
          v-for="(day, dayName, dayIndex) in period"
          :key="dayIndex"
          class="o-grid o-grid--gutter-large o-grid--padding-none o-grid--align-items-start o-field o-field--spacing-none o-field--border "
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--3">
              <div
                class="o-label"
                :title="translationsOpeningHours.weekdays[dayName] || ''"
              >
                {{ translationsOpeningHours.weekdays[dayName] || "" }}
              </div>
            </div>
            <div class="o-grid__item o-grid__item--3">
              <v-select
                label="name"
                :key="resetKey"
                v-model="day.status"
                :options="availabilityOptions"
                :class="{ active: isEditing }"
                :reduce="option => option.value"
                :searchable="true"
                :clearable="false"
                :filterBy="filterDropdownFistLetter"
                :disabled="!isEditing"
                :selectOnTab="true"
                @input="setClosed(periodIndex, dayName, $event)"
              ></v-select>
            </div>
            <div
              v-if="day.timespans.length > 0"
              class="o-grid__item o-grid__item--5"
            >
              <div
                v-for="(span, spanIndex) in day.timespans"
                :key="spanIndex"
                class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
              >
                <div class="o-grid__group">
                  <div class="o-grid__item o-grid__item--grow-0">
                    <v-time
                      v-model="span.begin"
                      :disabled="!isEditing"
                      :class="{
                        active: isEditing
                      }"
                    />
                  </div>
                  <div
                    class="o-grid__item o-grid__item--1"
                    style="text-align:center;"
                  >
                    -
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <v-time
                      v-model="span.end"
                      :disabled="!isEditing"
                      :class="{
                        active: isEditing
                      }"
                    />
                  </div>
                  <div
                    v-if="isEditing && spanIndex > 0"
                    class="o-grid__item o-grid__item--2"
                  >
                    <button
                      class="o-button o-button--action o-button--round o-button--light"
                      @click="deleteTimeSpan(periodIndex, dayName, spanIndex)"
                    >
                      <svg
                        class="o-svg-icon o-button__icon"
                        viewBox="0 0 64 64"
                        type="image/svg+xml"
                      >
                        <use
                          xlink:href="spritemap.svg#sprite-delete"
                          x="0"
                          y="0"
                        ></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
              >
                <div class="o-grid__group">
                  <div class="o-grid__item o-grid__item--12">
                    <button
                      type="button"
                      v-if="isEditing && canAddSpans(periodIndex, dayName)"
                      class="o-button o-button--transparent o-button--clean"
                      :title="translationsOpeningHours.addPeriod || ''"
                      @click="addTimeSpan(periodIndex, dayName)"
                    >
                      {{ translationsOpeningHours.addPeriod || "" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="o-grid o-grid--gutter-large o-grid--padding-none o-grid--align-items-center o-field o-field--spacing-none o-field--border o-field--border-none"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <button
            type="button"
            v-if="isEditing"
            class="o-button o-button--transparent o-button--clean"
            :title="translationsSpecialPeriods.addExeption || ''"
            @click.prevent="addSpecialPeriod"
          >
            <svg
              class="o-svg-icon o-button__icon o-button__icon--action  o-button__icon--shadow o-button__icon--round"
              viewBox="0 0 64 64"
              type="image/svg+xml"
            >
              <use xlink:href="spritemap.svg#sprite-plus" x="0" y="0"></use>
            </svg>
            <span>{{ translationsSpecialPeriods.addExeption || "" }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { da } from "vuejs-datepicker/dist/locale";
export default {
  name: "c-specialPeriods",
  data() {
    return {
      section: "availability",
      name: "Tilgængelighed",
      datepickerLanguage: da,
      resetKey: 0
    };
  },
  props: {
    isEditing: { type: Boolean, default: false }
  },
  computed: {
    ...mapState("availability", {
      availabilityAll: "all",
      defaultTimeSpan: "defaultTimeSpan",
      defaultSpecial: "defaultSpecial"
    }),
    ...mapState("aed", ["loading"]),
    ...mapGetters("aed", ["minimumSelectableDay"]),
    ...mapState("translations", {
      translationsAvailabilityFull: "availability"
    }),
    translationsSpecialPeriods() {
      return this.translationsAvailabilityFull.specialPeriods;
    },
    translationsOpeningHours() {
      return this.translationsAvailabilityFull.openingHours;
    },

    availabilityOptions() {
      const availabilityOptions = [
        {
          name: this.translationsOpeningHours.state[0] || "",
          value: "Closed"
        },
        {
          name: this.translationsOpeningHours.state[1] || "",
          value: "Open"
        }
      ];
      return availabilityOptions;
    }
  },
  methods: {
    addSpecialPeriod() {
      this.availabilityAll.special.push(
        JSON.parse(JSON.stringify(this.defaultSpecial))
      );
    },
    deleteSpecialPeriod(index) {
      this.availabilityAll.special.splice(index, 1);
    },
    setClosed(periodIndex, dayName, value) {
      let item = this.availabilityAll.special[periodIndex][dayName];
      item["status"] = value;
      if (item["status"] === "Closed") {
        item.timespans.length = 0;
      }
      if (item["status"] === "Open") {
        this.$set(
          item.timespans,
          0,
          JSON.parse(JSON.stringify(this.defaultTimeSpan))
        );
      }
    },
    addTimeSpan(periodIndex, dayName) {
      this.availabilityAll.special[periodIndex][dayName].timespans.push(
        JSON.parse(JSON.stringify(this.defaultTimeSpan))
      );
    },
    deleteTimeSpan(periodIndex, dayName, spanIndex) {
      this.availabilityAll.special[periodIndex][dayName].timespans.splice(
        spanIndex,
        1
      );
    },
    canAddSpans(periodIndex, dayName) {
      const canAddSpans =
        this.availabilityAll.special[periodIndex][dayName].status === "Open" &&
        this.availabilityAll.special[periodIndex][dayName].timespans.length < 3;
      return canAddSpans;
    },

    updatePeriodDays(periodIndex, type, value) {
      const formatedDay = moment(value).format("YYYY-MM-DD");
      Object.keys(this.availabilityAll.special[periodIndex]).forEach(
        day =>
          (this.availabilityAll.special[periodIndex][day][type] = formatedDay)
      );
    }
  }
};
</script>

<style lang="scss">
.c-specialPeriods {
  &__period {
    border: 1px solid $s-cp-neutral-600;
    margin-top: 20px;
    & + & {
      margin-top: 40px;
    }
  }

  &__timespans {
    text-align: center;
  }
  &__period-head {
    background-color: $s-cp-neutral-800;
  }

  &__period-head {
    padding: 0 15px 0 30px;
  }
  &__period-body {
    padding: 0 15px 20px 30px;
  }

  .c-aed-editableDate__input {
    color: $s-cp-neutral-400;
    border-radius: 3px;
  }
}
</style>
